<template>
  <b-card>
    <div style="position: relative">
      <loading-overlay :loading="jobsLoading"></loading-overlay>
      <validation-observer ref="addJobsValidation">
        <b-form class="auth-login-form" @submit.prevent>
          <div class="d-flex justify-content-between">
            <div>
              <h3>{{ $route.meta.pageTitle }}</h3>
            </div>
            <div>
              <b-button
                variant="outline-primary"
                class="p-50"
                @click="$router.go(-1)"
                ><feather-icon icon="ArrowLeftIcon" size="24"
              /></b-button>
            </div>
          </div>

          <hr />
          <b-row class="breadcrumbs-top">
            <b-col cols="4">
              <form-select
                label="مجال العمل"
                v-model="formInput.position_type"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="jobs_position_manage"
                ep="v2/guest/selects/positions"
                rules="required"
              />
            </b-col>
            <b-col cols="4">
              <form-input
                label="اسم الشاغر"
                id="basicInput"
                v-model="formInput.position"
                placeholder=""
                rules="required"
              />
            </b-col>

            <b-col cols="4">
              <form-input
                id="basicInput_code"
                label="رقم الشاغر"
                v-model="formInput.code"
                placeholder=""
                rules="required"
              />
            </b-col>
            <b-col cols="4">
              <form-select
                label="المحافظة"
                v-model="formInput.governorate"
                :getOptionLabel="(x) => x.name_ar"
                :reduce="(x) => x.id"
                id="sgovernorate_manage"
                ep="v2/guest/selects/governorates"
                rules="required"
              />
            </b-col>

            <b-col cols="4">
              <form-mask
                placeholder="YYYY-MM-DD"
                options="date"
                v-model="formInput.starting_date"
                label="تاريخ بداية الشاغر"
                rules="required"
                id="from_starting_date"
              />
            </b-col>

            <b-col cols="4">
              <form-mask
                placeholder="YYYY-MM-DD"
                options="date"
                v-model="formInput.closing_date"
                label="تاريخ نهاية الشاغر"
                rules="required"
                id="from_end_date"
              />
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="طبيعة الألتزام"
                style="
                  margin-top: 1.6rem !important;
                  margin-bottom: 1.6rem !important;
                "
              >
                <validation-provider
                  #default="{ errors }"
                  name="contractWorkSelect"
                  rules="required"
                >
                  <b-form-radio-group
                    class="mx-1"
                    v-model="formInput.contractWorkSelect"
                    :options="contractWork"
                    name="radios-stacked"
                    stacked
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{
                    errors[0] ? "الحقل مطلوب" : ""
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="">
              <b-form-group
                label="الغرض من الوظيفة"
                label-for="date"
                class="mb-5"
              >
                <validation-provider
                  #default="{ errors }"
                  name="opportunity_objectives"
                  rules="required"
                >
                  <quill-editor
                    v-model="formInput.opportunity_objectives"
                    :class="{ quillEditor: errors.length > 0 }"
                    :options="editorOption"
                  />
                  <small class="text-danger">{{
                    errors[0] ? "الحقل مطلوب" : ""
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="المؤهل العلمي" label-for="date" class="mb-5">
                <validation-provider
                  #default="{ errors }"
                  name="certificate"
                  rules="required"
                >
                  <quill-editor
                    v-model="formInput.certificate"
                    :class="{ quillEditor: errors.length > 0 }"
                    :options="editorOption"
                  />
                  <small class="text-danger">{{
                    errors[0] ? "الحقل مطلوب" : ""
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="المهارات" label-for="date" class="mb-5">
                <validation-provider
                  #default="{ errors }"
                  name="skills"
                  rules="required"
                >
                  <quill-editor
                    v-model="formInput.skills"
                    :class="{ quillEditor: errors.length > 0 }"
                    :options="editorOption"
                  />
                  <small class="text-danger">{{
                    errors[0] ? "الحقل مطلوب" : ""
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="الخبرات" label-for="date" class="mb-5">
                <validation-provider
                  #default="{ errors }"
                  name="experience"
                  rules="required"
                >
                  <quill-editor
                    v-model="formInput.experience"
                    :class="{ quillEditor: errors.length > 0 }"
                    :options="editorOption"
                  />
                  <small class="text-danger">{{
                    errors[0] ? "الحقل مطلوب" : ""
                  }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>

          <div>
            <b-button
              type="submit"
              v-if="
                $route.name == 'edit-jobs' || $route.name == 'edit-volunteer'
              "
              :disabled="jobsLoading"
              variant="primary"
              @click="formSubmitEdit"
              class="d-flex align-items-center justify-content-center"
            >
              <b-spinner
                v-if="jobsLoading"
                style="width: 1rem; height: 1rem"
                variant="light"
                class="mx-2"
              />
              تعديل
            </b-button>
            <b-button
              v-else
              type="submit"
              variant="primary"
              @click="formSubmitCreate"
              :disabled="jobsLoading"
              class="d-flex align-items-center justify-content-center"
            >
              <b-spinner
                v-if="jobsLoading"
                style="width: 1rem; height: 1rem"
                variant="light"
                class="mx-2"
              />
              إضافة
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </div>
  </b-card>
</template>

<script>
// eslint-disable-next-line

import "quill/dist/quill.snow.css";

import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";

import { quillEditor } from "vue-quill-editor";
import {
  BFormGroup,
  BForm,
  BFormInput,
  BCard,
  BRow,
  BCol,
  BButton,
  BFormRadioGroup,
  BSpinner,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import FormSelect from "@/components/form-select/index.vue";
import { mapGetters } from "vuex";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import FormInput from "@/components/form-input/index.vue";
import FormDatepicker from "@/components/form-datepicker/index.vue";
import FormMask from "@/components/form-mask/index.vue";

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
    BFormGroup,
    BForm,
    BFormInput,
    FormInput,
    FormSelect,
    Cleave,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormRadioGroup,
    BSpinner,
    BForm,
    LoadingOverlay,
    FormDatepicker,
    FormMask,
  },
  data: () => ({
    options: {
      date: {
        date: true,
        delimiter: "-",
        datePattern: ["Y", "m", "d"],
      },
    },
    editorOption: {
      modules: {
        toolbar: [
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ 'list': 'ordered'}, { 'list': 'bullet' }],
          ['link'],
        ]
      }
    },
    required,
    email,
    contractWork: [
      { value: "دوام كامل", text: "دوام كامل" },
      { value: "دوام جزئي", text: "دوام جزئي" },
      { value: "عن بعد", text: "عن بعد" },
    ],
    formInput: {
      position_type_id: "",
      contractWorkSelect: "",
      position: "",
      governorate_id: "",
      code: "",
      starting_date: "",
      closing_date: "",
      opportunity_objectives: ``,
      certificate: ``,
      experience: ``,
      skills: ``,
    },
  }),
  computed: {
    ...mapGetters("manageInterfaceNgo/jobsManage", ["jobsInfo", "jobsLoading"]),
  },
  methods: {
    formSubmitCreate() {
      this.$refs.addJobsValidation.validate().then(async (success) => {
        if (success) {
          this.addJobs();
        }
      });
    },
    formSubmitEdit() {
      this.$refs.addJobsValidation.validate().then(async (success) => {
        if (success) {
          this.editJobs();
        }
      });
    },
    async addJobs() {
      await this.$store.dispatch(`manageInterfaceNgo/jobsManage/createJob`, {
        name: this.formInput.position,
        type: this.$route.name == "add-jobs" ? "job" : "volunteer",
        code: this.formInput.code,
        opportunity_objectives_ar: this.formInput.opportunity_objectives,
        employment_type_ar: this.formInput.contractWorkSelect,
        position_type_id: this.formInput.position_type,
        closing_date: this.formInput.closing_date,
        starting_date: this.formInput.starting_date,
        governorate_id: this.formInput.governorate,
        skill_ar: this.formInput.skills,
        certificate_ar: this.formInput.certificate,
        experience_ar: this.formInput.experience,
      });
      this.redirectToIndex();
    },

    redirectToIndex() {
      if (this.$route.name == "add-jobs" || this.$route.name == "edit-jobs")
        this.$router.push({ name: "job-vacancies-management" });
      else this.$router.push({ name: "volunteer-vacancies-management" });
    },

    async editJobs() {
      await this.$store.dispatch(`manageInterfaceNgo/jobsManage/updateJob`, {
        id: this.$route.params.id,
        data: {
          name: this.formInput.position,
          type: this.$route.name == "edit-jobs" ? "job" : "volunteer",
          code: this.formInput.code,
          opportunity_objectives_ar: this.formInput.opportunity_objectives,
          employment_type_ar: this.formInput.contractWorkSelect,
          position_type_id: this.formInput.position_type,
          closing_date: this.formInput.closing_date,
          starting_date: this.formInput.starting_date,
          governorate_id: this.formInput.governorate,
          skill_ar: this.formInput.skills,
          certificate_ar: this.formInput.certificate,
          experience_ar: this.formInput.experience,
        },
      });
      this.redirectToIndex();
    },
  },

  async created() {
    if (this.$route.name == "add-jobs" || this.$route.name == "add-volunteer") {
      this.$store.dispatch(`manageInterfaceNgo/jobsManage/empeteJobsInfo`);
    } else {
      await this.$store.dispatch(`manageInterfaceNgo/jobsManage/getByJob`, {
        id: this.$route.params.id,
      });
      this.formInput = JSON.parse(JSON.stringify(this.jobsInfo));
    }
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";

.has-error {
  .vs__dropdown-toggle {
    border: 1px solid #ea5455 !important;
  }
}
.cleave-error {
  border: 1px solid #ea5455 !important;
}
.quillEditor {
  border: 1px solid #ea5455 !important;
}
</style>
